<template lang="pug">
  div(class="profile-eds-keys")
    div(class="profile-eds-keys__content")
      h4(class="text-16px fw-500 dark mb-1") {{ $t('EDS keys') }}
      div(class="text-12px") {{ $t('Select provider for creating new EDS key') }}
      div(class="profile-eds-keys__providers pt-6")
        div(class="profile-eds-keys__provider mono")
          div(class="profile-eds-keys__provider-icon mb-4")
            v-img(
              :src="require('~/assets/sprite/svg/monobank.svg')"
              :max-width="48"
            )
          div(class="profile-eds-keys__provider-content")
            h5(class="text-14px dark mb-1") {{ $t('MonoKEP') }}
            div(class="text-14px fw-300") {{ $t('Qualified electronic signatures from Monobank. Fast registration through the mobile application') }}
          div(class="profile-eds-keys__provider-actions")
            v-btn(
              class="main-button"
              @click="handleMonobank"
            ) {{ $t('Get KEP') }}
        div(class="profile-eds-keys__provider depositsign")
          div(class="profile-eds-keys__provider-badge text-12px") {{ $t('Soon') }}
          div(class="profile-eds-keys__provider-icon mb-4")
            v-img(
              :src="require('~/assets/sprite/svg/depositsign.svg')"
              :max-width="48"
            )
          div(class="profile-eds-keys__provider-content")
            h5(class="text-14px dark mb-1") DepositSign
            div(class="text-14px fw-300") {{  $t("Electronic signatures from Ukraine's leading CSP. Support for all types of document flow")  }}
          div(class="profile-eds-keys__provider-actions")
            v-btn(
              v-if="!isSent"
              :loading="loading"
              outlined
              dark
              @click="notifyDepositSign"
            ) {{ $t('Notify by email') }}
            div(
              v-else
              class="d-flex align-center"
            )
              div(class="profile-eds-keys__provider-icon-block")
                e-svg-icon(name="check-circle-green")
              div
                div(class="text-14px dark") {{ $t('You are among the first!') }}
                div(class="text-14px fw-300") {{ $t('We will notify you as soon as the service is available') }}
</template>

<script>
import contentDialog from '~/mixins/dialogs/contentDialog'
export default {
  name: 'BlockProfileEdsKeys',
  mixins: [contentDialog],
  data() {
    return {
      isSent: false,
      loading: false
    }
  },
  methods: {
    handleMonobank() {
      this.contentDialog.open({
        width: '724px',
        component: 'profile-mono-create-eds-key',
        removePadding: true,
        closeButtonProps: {
          alternative: true
        }
      })
    },
    async notifyDepositSign() {
      const scriptUrl =
        'https://script.google.com/macros/s/AKfycbxvp9wQhFHzn7T138Mq6XOZvaFLY3RanrpcVwUm1kChXoaBYOhR4I7nWaTND77gLg9E/exec'
      const data = new FormData()
      data.append('email', this.$User.email)
      data.append('created_at', this.$moment().format('DD.MM.YYYY HH:mm:ss'))
      if (this.$Organization) {
        data.append('edrpou', this.$Organization.edrpou)
        data.append('organization', this.$Organization.name)
      }
      try {
        this.loading = true
        await fetch(scriptUrl, {
          method: 'POST',
          body: data
        })
        this.isSent = true
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.profile-eds-keys {
  &__content {
    border-radius: 16px;
    border: 1px solid $border-disabled;
    padding: 16px;
  }

  &__providers {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__provider {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    border-radius: 12px;
    background-color: $background-gray;
    padding: 16px;
    height: auto;

    @media (min-width: map-get($breakpoints, 'sm')) {
      height: 240px;
    }

    &.mono {
      .v-btn {
        width: 100%;
        margin-top: 24px;

        @media (min-width: map-get($breakpoints, 'sm')) {
          width: 186px;
          margin-top: 0;
        }
      }
    }

    &.depositsign {
      .v-btn {
        width: 100%;
        margin-top: 24px;

        @media (min-width: map-get($breakpoints, 'sm')) {
          width: 206px;
          margin-top: 0;
        }
      }
    }
  }

  &__provider-badge {
    position: absolute;
    top: 16px;
    right: 16px;
    background-color: $white;
    color: #ffa04c;
    border-radius: 20px;
    padding: 4px 8px;
  }

  &__provider-icon-block {
    min-width: 48px;
    max-width: 48px;
    height: 48px;
    border-radius: 12px;
    background-color: $border-disabled;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
  }
}
</style>
